import { Brand } from './brand';

export const PLATFORM_COLOR = {
  [Brand.GP]: '#C0F826',
  [Brand.FM]: '#985EFF',
  // TODO: update to correct color
  [Brand.DAY1]: '#985EFF',
};
